import React, { useRef, useState, useEffect } from 'react';
import styles from '../../styles/PeriodosStyles/PeriodosScreen.module.css';

import { getInstitutions } from '../../api/institutions';

const defaultForm = {
  nombre: '',
  institucion: '',
  codigo: '',
  numPorAno: '',
  duracion: '',
  descripcion: '',
  estado: 'ACTIVO',
};

export default function NuevoPeriodoModal({ open, onClose, onSubmit, initialData = null, editMode = false }) {
  const [form, setForm] = useState(defaultForm);
  const [institutions, setInstitutions] = useState([]);
  const dialogRef = useRef(null);

  useEffect(() => {
    if (open) {
      loadInstitutions();
      if (editMode && initialData) {
        setForm({
          nombre: initialData.nombre || '',
          institucion: initialData.institucionId || '',
          codigo: initialData.codigo || '',
          numPorAno: initialData.numPorAno || '',
          duracion: initialData.duracion || '',
          descripcion: initialData.descripcion || '',
          estado: initialData.estado || 'ACTIVO',
        });
      } else {
        setForm(defaultForm);
      }
      // focus the first field
      setTimeout(() => {
        const first = dialogRef.current?.querySelector('input, select, textarea, button');
        first?.focus();
      }, 100);
    }
  }, [open, editMode, initialData]);

  const loadInstitutions = async () => {
    try {
      const data = await getInstitutions();
      setInstitutions(data);
    } catch (error) {
      console.error('Error al cargar instituciones:', error);
    }
  };

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit?.(form);
    onClose?.();
    setForm(defaultForm);
  };

  return (
    <div className={styles.modalBackdrop} role="presentation" onMouseDown={(e) => {
      if (e.target === e.currentTarget) onClose?.();
    }}>
      <div className={styles.modalContainer} role="dialog" aria-modal="true" aria-labelledby="np-title" ref={dialogRef}>
        <div className={styles.modalHeader} style={{ background: '#d1d1d1', padding: '18px 24px 12px', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}>
          <h2 id="np-title" className={styles.modalTitle} style={{ fontWeight: 700, fontSize: '20px', margin: 0 }}>
            {editMode ? 'Editar Periodo Académico' : 'Nuevo Periodo Académico'}
          </h2>
        </div>
        <form className={styles.modalBody} style={{ display: 'flex', flexDirection: 'column', gap: '18px', padding: '24px 32px 32px' }} onSubmit={handleSubmit}>
          <div className={styles.formGroup} style={{ display: 'flex', flexDirection: 'row', gap: '18px' }}>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label className={styles.label} style={{ fontWeight: 500 }}>Nombre del Periodo</label>
              <input name="nombre" value={form.nombre} onChange={handleChange} className={styles.input} style={{ height: '38px', borderRadius: '6px', border: '1px solid #ccc', padding: '0 10px' }} />
            </div>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label className={styles.label} style={{ fontWeight: 500 }}>Código del periodo</label>
              <input name="codigo" value={form.codigo} onChange={handleChange} className={styles.input} style={{ height: '38px', borderRadius: '6px', border: '1px solid #ccc', padding: '0 10px' }} />
            </div>
          </div>
          <div className={styles.formGroup} style={{ display: 'flex', flexDirection: 'row', gap: '18px' }}>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label className={styles.label} style={{ fontWeight: 500 }}>Institución</label>
              <select name="institucion" value={form.institucion} onChange={handleChange} className={styles.input} style={{ height: '38px', borderRadius: '6px', border: '1px solid #ccc', padding: '0 10px', color: '#222' }} required>
                <option value="">-- Selecciona una institución --</option>
                {institutions.map(inst => (
                  <option key={inst.id} value={inst.id}>{inst.name}</option>
                ))}
              </select>
            </div>
          </div>
          <div className={styles.formGroup} style={{ display: 'flex', flexDirection: 'row', gap: '18px' }}>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label className={styles.label} style={{ fontWeight: 500 }}>Número de periodos por año</label>
              <input name="numPorAno" value={form.numPorAno} onChange={handleChange} className={styles.input} type="number" style={{ height: '38px', borderRadius: '6px', border: '1px solid #ccc', padding: '0 10px' }} />
            </div>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label className={styles.label} style={{ fontWeight: 500 }}>Duración en semanas</label>
              <input name="duracion" value={form.duracion} onChange={handleChange} className={styles.input} type="number" style={{ height: '38px', borderRadius: '6px', border: '1px solid #ccc', padding: '0 10px' }} />
            </div>
          </div>
          <div className={styles.formGroup} style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label className={styles.label} style={{ fontWeight: 500 }}>Descripción</label>
            <textarea name="descripcion" value={form.descripcion} onChange={handleChange} className={styles.input} style={{ minHeight: '60px', borderRadius: '6px', border: '1px solid #ccc', padding: '8px 10px' }} />
          </div>
          <div className={styles.formGroup} style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label className={styles.label} style={{ fontWeight: 500 }}>Estado</label>
            <select name="estado" value={form.estado} onChange={handleChange} className={styles.input} style={{ height: '38px', borderRadius: '6px', border: '1px solid #ccc', background: form.estado === 'ACTIVO' ? '#e8f5e9' : '#ffebee', color: form.estado === 'ACTIVO' ? '#2e7d32' : '#c62828', fontWeight: 700, padding: '0 10px' }}>
              <option value="ACTIVO">ACTIVO</option>
              <option value="INACTIVO">INACTIVO</option>
            </select>
          </div>
          <div style={{ display: 'flex', gap: '18px', marginTop: '18px', justifyContent: 'center' }}>
            <button type="submit" style={{ background: '#1a3764', color: '#fff', fontWeight: 700, border: 'none', borderRadius: '6px', padding: '10px 38px', fontSize: '16px', boxShadow: '0 2px 6px rgba(0,0,0,0.15)' }}>GUARDAR</button>
            <button type="button" style={{ background: '#b7b7b7', color: '#fff', fontWeight: 700, border: 'none', borderRadius: '6px', padding: '10px 38px', fontSize: '16px', boxShadow: '0 2px 6px rgba(0,0,0,0.10)' }} onClick={onClose}>CANCELAR</button>
          </div>
        </form>
      </div>
    </div>
  );
}
